var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, observable, makeObservable } from 'mobx';
import { runtime } from '../../runtime/Runtime';
export class AnsweringStepCorrect {
    parent;
    dateOfLastCorrectStep;
    numberOfCorrectSteps = 0;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
    trackCorrect() {
        this.dateOfLastCorrectStep = runtime.runtimeClock.currentDate;
        this.numberOfCorrectSteps++;
    }
    hadCorrectStepInRecentMilliseconds(milliSeconds) {
        if (!this.dateOfLastCorrectStep)
            return false;
        return runtime.runtimeTimeSwitch.forTime(this.dateOfLastCorrectStep.getTime() + milliSeconds).isBelow;
    }
    get showCorrectFeedback_1500ms() {
        return this.hadCorrectStepInRecentMilliseconds(1500);
    }
    get showCorrectFeedback_500ms() {
        return this.hadCorrectStepInRecentMilliseconds(500);
    }
    get showCorrectFeedback_300ms() {
        return this.hadCorrectStepInRecentMilliseconds(300);
    }
}
__decorate([
    observable
], AnsweringStepCorrect.prototype, "dateOfLastCorrectStep", void 0);
__decorate([
    observable
], AnsweringStepCorrect.prototype, "numberOfCorrectSteps", void 0);
__decorate([
    action
], AnsweringStepCorrect.prototype, "trackCorrect", null);
__decorate([
    computed
], AnsweringStepCorrect.prototype, "showCorrectFeedback_1500ms", null);
__decorate([
    computed
], AnsweringStepCorrect.prototype, "showCorrectFeedback_500ms", null);
__decorate([
    computed
], AnsweringStepCorrect.prototype, "showCorrectFeedback_300ms", null);
